import { render, staticRenderFns } from "./AppInsuranceService.vue?vue&type=template&id=141cf085"
import script from "./AppInsuranceService.vue?vue&type=script&lang=js"
export * from "./AppInsuranceService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\nakatsukasa\\Herd\\cms.insag\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141cf085')) {
      api.createRecord('141cf085', component.options)
    } else {
      api.reload('141cf085', component.options)
    }
    module.hot.accept("./AppInsuranceService.vue?vue&type=template&id=141cf085", function () {
      api.rerender('141cf085', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/common/components/AppInsuranceService.vue"
export default component.exports